'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244 from "./presto.-Login-Helper$$anon$4.js";
import * as $j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024 from "./presto.types$proto$-Logoff-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginHelper$$anon$3() {
  this.b3S = null;
  this.b3K = null;
  this.b3L = false;
  this.b3T = null;
  this.b3U = false;
  this.b3X = null;
  this.b3Q = null;
  this.b3R = false;
  this.b3M = null;
  this.b3N = false;
  this.b3O = null;
  this.b3P = false;
  this.b3V = false;
  this.b3W = false;
  this.b3S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b3X = "LogoffResponse";
}
export { $c_Lpresto_LoginHelper$$anon$3 as $c_Lpresto_LoginHelper$$anon$3 };
$p = $c_Lpresto_LoginHelper$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginHelper$$anon$3;
/** @constructor */
function $h_Lpresto_LoginHelper$$anon$3() {
}
export { $h_Lpresto_LoginHelper$$anon$3 as $h_Lpresto_LoginHelper$$anon$3 };
$h_Lpresto_LoginHelper$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b3S;
});
$p.M = (function() {
  if ((!this.b3L)) {
    this.b3K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b3L = true;
  }
  return this.b3K;
});
$p.O = (function() {
  if ((!this.b3U)) {
    this.b3T = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b3U = true;
  }
  return this.b3T;
});
$p.E = (function() {
  return this.b3X;
});
$p.t = (function() {
  if ((!this.b3R)) {
    this.b3Q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("restored", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b3R = true;
  }
  return this.b3Q;
});
$p.N = (function() {
  if ((!this.b3N)) {
    this.b3M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b3N = true;
  }
  return this.b3M;
});
$p.Q = (function() {
  if ((!this.b3P)) {
    this.b3O = new $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244.$c_Lpresto_LoginHelper$$anon$4();
    this.b3P = true;
  }
  return this.b3O;
});
$p.v = (function() {
  if ((!this.b3W)) {
    this.b3V = false;
    this.b3W = true;
  }
  return this.b3V;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee27) => ((p) => \u03b4scrutinee27.cGj(p)))($j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024.$m_Lpresto_types$proto$LogoffResponse$())));
});
var $d_Lpresto_LoginHelper$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginHelper$$anon$3, "presto.LoginHelper$$anon$3", ({
  M6: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginHelper$$anon$3 as $d_Lpresto_LoginHelper$$anon$3 };
//# sourceMappingURL=presto.-Login-Helper$$anon$3.js.map
